import React from 'react';
import {View} from 'react-native';

import Avatar from '/component/base/Avatar';
import TouchableOpacity from '/component/base/TouchableOpacity';
import Gutter from '/component/layout/Gutter';
import Timestamp from '/component/partial/Timestamp';
import {DashboardID} from '/constant/TestIDs';
import testProperties from '/util/testing/testProperties';

import Greeting from './Greeting';
import {styles} from './Header.style';
import {HeaderProps} from './Header.types';

export const Header = ({
  onShowRefreshInfoPopover,
  onShowMyProfile,
  avatar,
  email,
  name,
}: HeaderProps) => (
  <>
    <Gutter>
      <TouchableOpacity
        {...testProperties(null, true)}
        style={styles.header}
        accessibilityLabel={`User profile. Name: ${name}`}
        importantForAccessibility="yes"
        accessible={false}
        onPress={onShowMyProfile}>
        <View
          {...testProperties(DashboardID.dashboardAvatar)}
          style={styles.headerAvatar}>
          <Avatar
            size={64}
            avatarUrl={avatar}
            accessibilityLabel={`Avatar of ${name}`}
            importantForAccessibility="yes"
            avatarKey={email}
            fullName={name}
          />
        </View>
        <Greeting
          importantForAccessibility="yes"
          style={{base: styles.headerGreeting}}
          name={name}
        />
      </TouchableOpacity>
    </Gutter>
    <Timestamp
      importantForAccessibility="yes"
      onShowInfoPopover={onShowRefreshInfoPopover}
      style={{base: styles.timestampContainer}}
      infoButtonLabel="Show dashboard data refresh info"
    />
  </>
);
